<app-hero title="{{ 'title' | translate }}" imageUrl="assets/images/press/hero-quienes-somos.png"
    [imageSettings]="{width: 750, height: 750}"></app-hero>

<app-aptitudes></app-aptitudes>

<app-info-block class="info-block-special">
    <app-team></app-team>
</app-info-block>

<app-flyer-saldo backgroundImage="../../assets/landing-social-proof/flyer1.svg">
    <div class="container-flyer centered-div">
        <h2>{{ 'time_helping_people_banner_text' | translate }}</h2>
        <button (click)="this.router.navigate([''])" mat-button>{{ 'time_helping_people_banner_button' | translate
            }}</button>
    </div>
</app-flyer-saldo>

<div class="rs-wrapper-v4 default-space-between-components">
    <h2>{{ 'related_news_title' | translate }}</h2>
    <app-slide (draggingEvent)="receiveEvent($event)" [margin]="27" [elementWidth]="283"
        [elementQty]="relatedSaldoNews.length">
        <ng-container *ngIf="relatedSaldoNews.length !== 0">
            <app-help-card [notRedirect]="notRedirect" *ngFor="let item of relatedSaldoNews" [dataCardHelp]="item">
            </app-help-card>
        </ng-container>
    </app-slide>
</div>

<div class="default-space-between-components rs-wrapper-v4" id="press">
    <h2>{{ 'press_download_title' | translate }} </h2>
    <app-resource></app-resource>
</div>
